import React, { useEffect, useRef } from 'react';

interface MapComponentMarkerProps {
    map: google.maps.Map;
    position: google.maps.LatLngLiteral;
    marker: {
        latitude: number;
        longitude: number;
        distance: null | number;
        name: string;
        url: string;
    };
}

const MapComponentMarker: React.FC<MapComponentMarkerProps> = ({ map, position, marker }) => {
    const overlayRef = useRef<google.maps.OverlayView | null>(null);

    useEffect(() => {
        const overlay = new google.maps.OverlayView();
        let div: HTMLDivElement | null = null;

        overlay.onAdd = function () {
            div = document.createElement('div');
            div.style.position = 'absolute';
            div.style.transform = 'translate(-50%, -100%)';

            if (!marker.distance) {
                div.className = "map-marker order-marker";
                div.innerHTML = `
                <div class='marker-name'>${marker.name}</div>
                <div class='marker-pointer'></div>`;
            } else {
                div.className = "map-marker";
                div.innerHTML = `
                <img src=${marker.url} 
                onerror="this.onerror=null; 
                this.src='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAyNTAgMjUwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI2Ni40MyAtNDAxLjY1KSI+CiAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoLjY4MzMzIDAgMCAuNjgzMzMgNTgxLjk0IDU1MC43NykiIGZpbGw9IiNEREREREQiPgogICA8cmVjdCB4PSItNDYxLjczIiB5PSItMjE4LjIzIiB3aWR0aD0iMzY1Ljg1IiBoZWlnaHQ9IjM2NS44NSIgcng9IjAiIHJ5PSIwIiBjb2xvcj0iIzAwMDAwMCIgZmlsbD0iI0RERERERCIvPgogIDwvZz4KICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCguMzQ5MiAwIDAgLjM0OTIgMjg0LjU3IDQxOS43OSkiIGZpbGw9IiNGRkYiPgogICA8ZyBmaWxsPSIjRkZGIj4KICAgIDxwYXRoIGQ9Im0zMDYgMzI1Ljk5YzkwLjU2LTAuMDEgMTIzLjE1LTkwLjY4IDEzMS42OC0xNjUuMTcgMTAuNTEtOTEuNzYtMzIuODgtMTYwLjgyLTEzMS42OC0xNjAuODItOTguNzggMC0xNDIuMTkgNjkuMDU1LTEzMS42OCAxNjAuODIgOC41NCA3NC40ODQgNDEuMTE0IDE2NS4xOCAxMzEuNjggMTY1LjE3eiIvPgogICAgPHBhdGggZD0ibTU1MC45OCA1NDEuOTFjLTAuOTktMjguOTA0LTQuMzc3LTU3LjkzOS05LjQyMS04Ni4zOTMtNi4xMTEtMzQuNDY5LTEzLjg4OS04NS4wMDItNDMuOTgzLTEwNy40Ni0xNy40MDQtMTIuOTg4LTM5Ljk0MS0xNy4yNDktNTkuODY1LTI1LjA4MS05LjY5Ny0zLjgxLTE4LjM4NC03LjU5NC0yNi41MzctMTEuOTAxLTI3LjUxOCAzMC4xNzYtNjMuNCA0NS45NjItMTA1LjE5IDQ1Ljk2NC00MS43NzQgMC03Ny42NTItMTUuNzg2LTEwNS4xNy00NS45NjQtOC4xNTMgNC4zMDgtMTYuODQgOC4wOTMtMjYuNTM3IDExLjkwMS0xOS45MjQgNy44MzItNDIuNDYxIDEyLjA5Mi01OS44NjMgMjUuMDgxLTMwLjA5NiAyMi40NjMtMzcuODczIDcyLjk5Ni00My45ODMgMTA3LjQ2LTUuMDQ1IDI4LjQ1NC04LjQzMyA1Ny40ODktOS40MjIgODYuMzkzLTAuNzY2IDIyLjM4NyAxMC4yODggMjUuNTI1IDI5LjAxNyAzMi4yODQgMjMuNDUzIDguNDU4IDQ3LjY2NiAxNC43MzcgNzIuMDQxIDE5Ljg4NCA0Ny4wNzcgOS45NDEgOTUuNjAzIDE3LjU4MiAxNDMuOTIgMTcuOTI0IDQ4LjMxOC0wLjM0MyA5Ni44NDQtNy45ODMgMTQzLjkyLTE3LjkyNCAyNC4zNzUtNS4xNDUgNDguNTktMTEuNDI0IDcyLjA0MS0xOS44ODQgMTguNzM2LTYuNzU3IDI5Ljc4OS05Ljg5NSAyOS4wMjMtMzIuMjg0eiIvPgogICA8L2c+CiAgPC9nPgogPC9nPgo8L3N2Zz4K';">
                <div>
                    <div class='marker-name'>${marker.name}</div>
                    <div class='marker-distance'>${marker.distance} km</div>
                </div>
                <div class='marker-pointer'"></div>`;
            }

            const panes = this.getPanes();
            panes.overlayLayer.appendChild(div);
        };

        overlay.draw = function () {
            if (!div) return;

            const overlayProjection = this.getProjection();
            const sw = overlayProjection.fromLatLngToDivPixel(position);

            div.style.left = `${sw.x}px`;
            div.style.top = `${sw.y}px`;
        };

        overlay.onRemove = function () {
            if (div && div.parentNode) {
                div.parentNode.removeChild(div);
                div = null;
            }
        };

        overlay.setMap(map);
        overlayRef.current = overlay;

        return () => {
            overlay.setMap(null);
        };

    }, [map, position, marker]);

    return null;
};

export default MapComponentMarker;


